import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Tab } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "../../../App";
import { getLoggedInUser, getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import List from "./List";
import AddTemplates from "./AddTemplate";

const Templates = ({ token, loggedInUser }) => {
  const addLovModal = useRef();
  const dispatch = useDispatch();
  useEffect(() => {

  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Tab.Container defaultActiveKey={"List"}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="heading mb-0">Templates</h4>
              <div className="d-flex align-items-center">
                <Link
                  to
                  className="btn btn-primary btn-sm ms-2"
                  onClick={() => addLovModal.current.showAddLovModal()}
                >
                  + Add New Templates
                </Link>
              </div>
            </div>
            <div className="col-xl-12 active-p">
              <Tab.Content>
                <Tab.Pane eventKey={"List"}>
                  <List title="Templates" />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
      <AddTemplates
        ref={addLovModal}
        Title="Add New Template"
        token={token}
        loggedInUser={loggedInUser}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(Templates));
